<template>
  <span>
    <VuePersianDatetimePicker
      :format="field.filter.format != undefined ? field.filter.format : `HH:mm`"
      display-format="HH:mm"
      simple
      type="time"
      @input="$emit('input', $event)"
    />
  </span>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
  components: {
    VuePersianDatetimePicker,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      operators: [
        {
          value: '$lk',
          text: 'مشابه',
        },
        {
          value: '$eq',
          text: 'مساوی',
        },
        {
          value: '$ne',
          text: 'نامساوی',
        },
        {
          value: '$startsWith',
          text: 'شروع با',
        },
        {
          value: '$endsWith',
          text: 'پایان با',
        },
      ],
    }
  },
}
</script>
